import {
  FaBuilding,
  FaCompass,
  FaGears,
  FaHouse,
  FaLandmark,
  FaMapLocationDot,
  FaMugHot,
  FaSchool,
  FaStethoscope,
} from 'react-icons/fa6';

export type IndustrySolutionLink = {
  label: string;
  href: string;
};

export type IndustryCard = {
  id: number;
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  keySolutions: IndustrySolutionLink[];
};

export const industriesData: IndustryCard[] = [
  {
    id: 1,
    icon: FaMapLocationDot,
    title: 'Mining & Resources',
    description:
      'Comprehensive security, fire suppression, HVAC, and communication systems for mining operations in Katanga and beyond.',
    keySolutions: [
      { label: 'CCTV Systems', href: '/solutions/security-and-surveillance#cctv-visual-monitoring' },
      { label: 'Vehicle Fire Suppression', href: '/solutions/fire-protection#vehicle-fire-systems' },
      { label: 'Access Control', href: '/solutions/security-and-surveillance#access-control' },
      { label: 'Solar Power', href: '/solutions/solar-energy#off-grid-systems' },
      { label: 'Communication Systems', href: '/solutions/it-infrastructure#unified-communications' }
    ]
  },
  {
    id: 2,
    icon: FaStethoscope,
    title: 'Healthcare',
    description:
      'Reliable IT infrastructure, fire safety, and climate control systems ensuring patient safety and operational continuity.',
    keySolutions: [
      { label: 'Fire Detection', href: '/solutions/fire-protection#fire-detection' },
      { label: 'Climate Control', href: '/solutions/hvac-solutions#building-controls' },
      { label: 'Network Infrastructure', href: '/solutions/it-infrastructure#network-infrastructure' },
      { label: 'Access Control', href: '/solutions/security-and-surveillance#access-control' },
      { label: 'Backup Power', href: '/solutions/solar-energy#inverters-storage' }
    ]
  },
  {
    id: 3,
    icon: FaBuilding,
    title: 'Corporate & Office',
    description:
      'Smart building solutions combining security, climate control, IT infrastructure, and automation for modern workplaces.',
    keySolutions: [
      { label: 'Building Automation', href: '/solutions/hvac-solutions#building-controls' },
      { label: 'Access Control', href: '/solutions/security-and-surveillance#access-control' },
      { label: 'VRF Systems', href: '/solutions/hvac-solutions#vrf-systems' },
      { label: 'Network Infrastructure', href: '/solutions/it-infrastructure#network-infrastructure' },
      { label: 'Unified Communications', href: '/solutions/it-infrastructure#unified-communications' }
    ]
  },
  {
    id: 4,
    icon: FaLandmark,
    title: 'Government & Public',
    description:
      'High-security systems and reliable infrastructure for government buildings, public facilities, and confidential properties.',
    keySolutions: [
      { label: 'Perimeter Security', href: '/solutions/security-and-surveillance#perimeter-security' },
      { label: 'Fire Protection', href: '/solutions/fire-protection#fire-suppression' },
      { label: 'Secure Communications', href: '/solutions/it-infrastructure#unified-communications' },
      { label: 'Surveillance Systems', href: '/solutions/security-and-surveillance#video-analytics' },
      { label: 'Data Center Solutions', href: '/solutions/it-infrastructure#server-solutions' }
    ]
  },
  {
    id: 5,
    icon: FaMugHot,
    title: 'Hospitality',
    description:
      'Guest comfort and safety through integrated HVAC, security, lighting, and smart room control systems.',
    keySolutions: [
      { label: 'Climate Control', href: '/solutions/hvac-solutions#building-controls' },
      { label: 'Smart Automation', href: '/solutions/it-infrastructure#smart-and-home-automation' },
      { label: 'Security Systems', href: '/solutions/security-and-surveillance#perimeter-security' },
      { label: 'LED Lighting', href: '/solutions/solar-energy#industrial-led' },
      { label: 'Guest Wi-Fi', href: '/solutions/it-infrastructure#guest-wifi-solutions' }
    ]
  },
  {
    id: 6,
    icon: FaCompass,
    title: 'Aviation & Transport',
    description:
      'Airport and transport hub security with advanced surveillance, access control, and fire safety systems.',
    keySolutions: [
      { label: 'Airport Surveillance', href: '/solutions/security-and-surveillance#airport-surveillance' },
      { label: 'Perimeter Security', href: '/solutions/security-and-surveillance#perimeter-security' },
      { label: 'Fire Alarms', href: '/solutions/fire-protection#fire-alarms' },
      { label: 'Communication Systems', href: '/solutions/it-infrastructure#unified-communications' },
      { label: 'Access Control', href: '/solutions/security-and-surveillance#access-control' }
    ]
  },
  {
    id: 7,
    icon: FaSchool,
    title: 'Education',
    description:
      'Safe learning environments with integrated security, fire protection, and IT infrastructure for schools and universities.',
    keySolutions: [
      { label: 'Fire Alarms', href: '/solutions/fire-protection#fire-alarms' },
      { label: 'Network Infrastructure', href: '/solutions/it-infrastructure#network-infrastructure' },
      { label: 'CCTV Systems', href: '/solutions/security-and-surveillance#cctv-visual-monitoring' },
      { label: 'Air Cleaning', href: '/solutions/hvac-solutions#air-cleaning' }
    ]
  },
  {
    id: 8,
    icon: FaGears,
    title: 'Industrial & Manufacturing',
    description:
      'Robust security, fire suppression, and environmental control systems for factories, warehouses, and production facilities.',
    keySolutions: [
      { label: 'Warehouse Security', href: '/solutions/security-and-surveillance#warehouse-security' },
      { label: 'Industrial Fire Suppression', href: '/solutions/fire-protection#fire-suppression' },
      { label: 'Duct Installation', href: '/solutions/hvac-solutions#duct-air-distribution' },
      { label: 'Solar Power', href: '/solutions/solar-energy#commercial-panels' },
      { label: 'Maintenance Services', href: '/solutions/maintenance-support#preventive' }
    ]
  },
  {
    id: 9,
    icon: FaHouse,
    title: 'Residential & Luxury',
    description:
      'Premium home automation, security, and comfort systems for high-end residential properties.',
    keySolutions: [
      { label: 'Home Automation', href: '/solutions/it-infrastructure#smart-and-home-automation' },
      { label: 'Smart Security', href: '/solutions/security-and-surveillance#video-analytics' },
      { label: 'Climate Control', href: '/solutions/hvac-solutions#vrf-systems' },
      { label: 'Solar Energy', href: '/solutions/solar-energy#off-grid-systems' },
      { label: 'LED Lighting', href: '/solutions/solar-energy#industrial-led' }
    ]
  }
];
